import styled from 'styled-components';
import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { IDialogActions, IDialogTitle, IGeneralDialog } from './generalDialog.types';

export const StyledGeneralDialog = styled(Dialog) <IGeneralDialog>`
  ${({ theme, commonStyles }) => `
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    z-index: ${commonStyles?.zIndex ?? 1300} !important;

    .MuiPaper-root {
      width: ${commonStyles?.width};
      border: ${commonStyles?.border ?? 'none'};
    }

    .MuiPaper-rounded {
      border-radius: ${theme.uptimeSpace[6]}px;
      max-width: ${commonStyles?.maxWidth ?? 600}px;
      display: ${commonStyles?.display || 'flex'};
    }

    .MuiDialogContent-root {
      ${!!commonStyles?.padding ? `padding: ${commonStyles?.padding}` : `padding: ${theme.uptimeSpace[12]}px ${theme.uptimeSpace[12]}px 0`} !important;
    }

    .general-dialog-content {
      overflow: hidden;
      font-size: ${commonStyles?.contentFontSize ?? theme.uptimeFontSizes.desktop.fz4}px !important;
      font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
      line-height: initial;
    }

    .general-dialog-content p {
      font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px !important;
      line-height: ${theme.uptimeLineHeights.desktop.lh3}px !important
    }

    .MuiInputBase-root .MuiInputBase-input {
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      font-weight: 400;
    }

    .MuiFormControlLabel-root{
      margin-left: -10px;
    }

    .PhoneInputWrapper {
      margin-top: ${theme.uptimeSpace[7]}px;
    }

    .PhoneInputInput {
      color: ${theme.uptimeColors.textColors.primary};
      height: ${theme.uptimeSpace[18]}px;
      padding: ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[8]}px;
      border-radius: ${theme.uptimeSpace[2]}px;
      background: none !important;
      outline: none;
    }
    .PhoneInputInput:hover {
      border: solid 1px ${theme.uptimeColors.grayScales.black} !important;
    }
    .PhoneInput--focus .PhoneInputInput {
      border: solid 1px ${theme.uptimeColors.mainTheme.secondary} !important;
      box-shadow: 0 0 0 1px ${theme.uptimeColors.mainTheme.secondary} !important;
    }
    .PhoneNumberError .PhoneInputInput {
      color: ${theme.uptimeColors.generalColors.state.danger.light};
      border-color: ${theme.uptimeColors.generalColors.state.danger.light};
    }
    .PhoneNumberError.PhoneInput--focus .PhoneInputInput {
      box-shadow: 0 0 0 1px ${theme.uptimeColors.generalColors.state.danger.light};
    }
    .err-msg {
      color: ${theme.uptimeColors.generalColors.state.danger.light};
      font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
      margin: ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[10]}px ${theme.uptimeSpace[0]};
    }

    .txt-title {
      font-weight: bold;
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
      margin-top: ${theme.uptimeSpace[0]};
    }

    .email-form-dialog .form-left-title {
      font-weight: bold;
      margin-bottom: ${theme.uptimeSpace[5]}px;
    }
  
    .email-form-dialog .MuiTypography-body1 {
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    }

    .form-left-title {
      display: flex;
      align-items: center;
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    }

    .form-left-title label::after {
      color: ${theme.uptimeColors.generalColors.state.danger.light};
      content: " *";
    }

    .form-left-title .label-optional::after {
      content: "";
      padding-right: ${theme.uptimeSpace[6]}px;
    }

    .form-left-title .title-validated {
      color: ${theme.uptimeColors.textColors.primary};
    }

    .text-dialog-content {
      flex: 1;
    }

    .delegation-content {
        padding: 0px ${theme.uptimeSpace[3]}px 0 ${theme.uptimeSpace[5]}px;
    }
    .enable-wrapper {
        margin-top: ${theme.uptimeSpace[5]}px;
        display: flex;
        align-items: center;
        .enable-checkbox {
            color: ${theme.uptimeColors.grayScales.darkerGray};  
            padding: ${theme.uptimeSpace[3]}px;
            margin-left: -${theme.uptimeSpace[3]}px;
            margin-right: ${theme.uptimeSpace[3]}px;
        }
        .MuiCheckbox-colorSecondary.Mui-checked {
          color: ${theme.uptimeColors.mainTheme.primary};
        }
        .MuiIconButton-root:hover {
          background-color: ${theme.uptimeColors.mainTheme.background};
        } 
    }

    &.pickup-location-dialog {
      .select-control {
        width: 100%;
      }
    }
  `}
`;

export const StyledDialogTitle = styled(DialogTitle)<IDialogTitle>(
  ({
    theme,
    justifyContentTitle = 'flex-start',
    isHeaderDefault = true,
    isHeaderBackgroundDefault = true,
  }) => `

  background-color: ${
    isHeaderBackgroundDefault
      ? 'transparent' // don't define background default yet, the transparent value for temporary
      : theme.uptimeColors.generalColors.dialogTitle.background
  };
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: ${justifyContentTitle};
  padding: ${theme.uptimeSpace[8]}px 15px;

  .title-wrapper {
    font-size: ${theme.uptimeFontSizes.desktop.fz6}px;
    font-weight: 600;
    line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
  }

  .title {
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    color: ${isHeaderDefault ? theme.uptimeColors.generalColors.dialogTitle.color : theme.uptimeColors.mainTheme.primary};
  }

  .button-close {
    position: absolute;
    right: ${theme.uptimeSpace[0]}px;
    top:  ${theme.uptimeSpace[0]}px;
    padding: 15px ${theme.uptimeSpace[8]}px;
    border-radius: 50%;
    color: ${theme.uptimeColors.textColors.primary};
  }

  .customized-dialog-close-button{
    position: absolute;
    right: ${theme.uptimeSpace[5]}px;
    top: 5px;
  }

`
);

export const StyledDialogActions = styled(DialogActions)<IDialogActions>(
  ({ theme, justifyContentAction = 'flex-end', commonStyles, isMarketPlaceContent }) => `
  justify-content: ${justifyContentAction} !important;
  padding: ${commonStyles?.padding ?? `${theme.uptimeSpace[12]}px ${theme.uptimeSpace[12]}px ${theme.uptimeSpace[8]}px`} !important;

  .dialog-button-component {
    padding: ${theme.uptimeSpace[3]}px ${theme.uptimeSpace[8]}px;
    border-radius: ${theme.uptimeSpace[2]}px;
    color: ${theme.uptimeColors.grayScales.white};
    text-transform: uppercase;
    background: ${theme.uptimeColors.mainTheme.primary};
  }

  .dialog-button-component:hover {
    background: ${theme.uptimeColors.mainTheme.primary};
  }

  .dialog-button-component.Mui-disabled {
    background-color: ${theme.uptimeColors.grayScales.gray}  !important;
  }

  .MuiButton-contained{
    ${!!commonStyles?.btnWidth ? `min-width: ${commonStyles?.btnWidth}` : ''};
  }

  .MuiButton-outlined {
    border: 1px solid ${theme.uptimeColors.mainTheme.primary};
    ${!!commonStyles?.btnWidth ? `min-width: ${commonStyles?.btnWidth}` : ''};
    padding: 5px 15px;
  }
`
);
